import React from 'react';
import { Link } from 'react-router-dom';

const sportsData = [
  {
    title: 'Futsal',
    imageUrl: 'https://aivg.azmiproductions.com/sukas/FUTSAL.png',
    link: '/futsal',
  },
  {
    title: 'Volleyball (Brothers)',
    imageUrl: 'https://aivg.azmiproductions.com/sukas/VOLLEYBALL.png',
    link: '/volleyballb',
  },
  {
    title: 'Badminton ( Brothers )',
    imageUrl: 'https://aivg.azmiproductions.com/sukas/BADMINTON.png',
    link: '/badmintonb',
  },
  {
    title: 'Badminton ( Sisters )',
    imageUrl: 'https://aivg.azmiproductions.com/sukas/BADMINTON.png',
    link: '/badmintons',
  },
  {
    title: 'Netball',
    imageUrl: 'https://aivg.azmiproductions.com/sukas/NETBALL.png',
    link: '/netball',
  },
  {
    title: 'Team Standings',
    imageUrl: 'https://aivg.azmiproductions.com/sukas/AZMI%20PRODUCTION_20250515_140304_0000.png',
    link: '/scoreboard',
  },
];

const Landing = () => {
  return (
    <div
      className="min-h-screen py-10 flex items-center justify-center"
      style={{
        backgroundImage: `url('https://aivg.azmiproductions.com/sukas/backsukas.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="bg-gray-300 bg-opacity-60 rounded-lg shadow-lg p-8 text-center">
        
        {/* Add the image above the title */}
        <img
          src="https://azmiproductions.com/assets/img/lokas.png"  // Replace with the actual image URL
          alt="Event Logo"
          className="mx-auto mb-4 w-24 h-24" // Center the image, add margin, and size it
        />
        
        <h1 className="text-black text-2xl uppercase font-extrabold mb-1">SUKAN ANAK SABAH 2.0</h1>
        <h1 className="text-black text-lg uppercase font-extrabold mb-12">Powered By Azmi Productions</h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {sportsData.map((sport, index) => (
            <div
              key={index}
              className="rounded-lg overflow-hidden shadow-md transform transition-transform duration-300 hover:scale-105"
              style={{
                backgroundImage: 'linear-gradient(135deg, #d19eb5, #e9e9e9)', // Gradient from #33888D to a darker shade
              }}
            >
              <img src={sport.imageUrl} alt={sport.title} className="w-full h-48 object-cover" />
              <div className="p-4 text-center">
                <h5 className="text-black text-xl font-semibold mb-2">{sport.title}</h5>
                <Link
                  to={sport.link}
                  className="inline-block mt-2 px-6 py-2 rounded-full bg-gray-700 text-white text-lg font-semibold transition-colors duration-300 hover:bg-gray-900"
                >
                  Watch
                </Link>
              </div>
            </div>
          ))}
        </div>
        
      </div>
      
    </div>
  );
};

export default Landing;
